import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ServiceHero from "../components/services/ServiceHero";

const ABOUT_IMAGE_1 = "https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5eliiIemdtu1Lq78DWpb5GMcYTwH6JeySIjEdz";
const ABOUT_IMAGE_2 = "https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5eEAi4JLt2qjTRitskul7YMHafL6SbJIUeoDBN";
const ABOUT_IMAGE_3 = "https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5eMduq9p7v1Y4gRuy7A36MHtmraLfbJoN0i5lk";

const About = () => {
  return (
    <div id="about">
      <Navbar />
      <div className="">
        <ServiceHero />
      </div>

      {/* Section 1: About AWM - Image Left, Text Right */}
      <section className="bg-white py-16 md:py-24 px-4 sm:px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            {/* Image on Left */}
            <div className="relative order-1">
              <div className="relative overflow-hidden rounded-2xl shadow-xl transform hover:scale-105 transition-transform duration-500">
                <img
                  src={ABOUT_IMAGE_1}
                  alt="AWM Bridal Makeup Service"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 hover:opacity-100 transition duration-300"></div>
              </div>
            </div>

            {/* Text Content on Right */}
            <div className="space-y-6 order-2 text-center lg:text-left">
              <h2 className="text-hero font-medium text-black relative inline-block font-display">
                About AWM
              </h2>
              <p className="text-base sm:text-lg md:text-xl text-black leading-relaxed">
                AWM is a premium on-location bridal makeup and hair service with 10+ years of expertise and 500+ elegant bridal makeovers across India. Combining celebrity artists, personalized consultations, luxury products, and moodboard-led styling, AWM delivers flawless, long-lasting beauty with seamless convenience—making every bride feel confident, radiant, and picture-perfect.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: How AWM Started - Image Right, Text Left */}
      <section className="bg-beige py-16 md:py-24 px-4 sm:px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            {/* Text Content on Left */}
            <div className="space-y-6 order-2 lg:order-1 text-center lg:text-left">
              <h2 className="text-hero font-medium text-black relative inline-block font-display">
                How AWM Started
              </h2>
              <p className="text-base sm:text-lg md:text-xl text-black leading-relaxed">
                AWM began with one simple belief — every bride deserves world-class artistry without stress. What started as a passion project by Aastha soon grew into a nationwide, on-venue bridal service trusted for precision and premium results. Driven by experience, innovation, and empathy, AWM has redefined convenience by bringing elite talent and luxury makeup directly to brides across India.
              </p>
            </div>

            {/* Image on Right */}
            <div className="relative order-1 lg:order-2">
              <div className="relative overflow-hidden rounded-2xl shadow-xl transform hover:scale-105 transition-transform duration-500">
                <img
                  src={ABOUT_IMAGE_2}
                  alt="How AWM Started"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 hover:opacity-100 transition duration-300"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: What Makes AWM Different - Image Left, Text Right */}
      <section className="bg-white py-16 md:py-24 px-4 sm:px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            {/* Image on Left */}
            <div className="relative order-1">
              <div className="relative overflow-hidden rounded-2xl shadow-xl transform hover:scale-105 transition-transform duration-500">
                <img
                  src={ABOUT_IMAGE_3}
                  alt="AWM Premium Bridal Services"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 hover:opacity-100 transition duration-300"></div>
              </div>
            </div>

            {/* Text Content on Right */}
            <div className="space-y-6 order-2 text-center lg:text-left">
              <h2 className="text-hero font-medium text-black relative inline-block font-display">
                What Makes AWM Different in Today's Time
              </h2>
              <p className="text-base sm:text-lg md:text-xl text-black leading-relaxed">
                In a world of rushed appointments and generic styling, AWM stands apart with personalized luxury, handpicked celebrity artists, and a seamless process that revolves around you. Our moodboard approach, skin-first philosophy, and premium product curation ensure unmatched quality. Every detail — from consultation to final glam — is intentional, elevating your bridal journey into an effortless, high-touch experience.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
